export class CustomerOptions {
  useLetterAttachments: boolean;
  displayQBDropCoverageMessage: boolean;
}
